import React from 'react';
import { InjectedRouter, PlainRoute } from 'react-router';

type Routing = {
  router: InjectedRouter;
  route: PlainRoute;
};

const RoutingContext = React.createContext<Routing | null>(null);

export const RoutingProvider = ({
  children,
  routing,
}: {
  children: React.ReactNode;
  routing: Routing;
}) => {
  const { router, route } = routing;
  if (!router) {
    throw new Error('RoutingProvider requires a router prop');
  }
  if (!route) {
    throw new Error('RoutingProvider requires a route prop');
  }

  const value = React.useMemo(() => ({ router, route }), [router, route]);

  return (
    <RoutingContext.Provider value={value}>{children}</RoutingContext.Provider>
  );
};

export const useRouting = () => React.useContext(RoutingContext);
